(() => {
  'use strict';

  if (window.NativeSizeGuide) return;

  const mountedDialogs = new Map();

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    document.documentElement.style.overflow = '';
  };

  const openDialog = (button) => {
    const templateId = button.dataset.sizeGuideOpen;
    let dialog = mountedDialogs.get(templateId);

    if (!dialog || !dialog.isConnected) {
      const template = document.getElementById(templateId);

      if (!(template instanceof HTMLTemplateElement)) {
        console.warn(`[Size guide] Template #${templateId} was not found.`);
        return;
      }

      const fragment = template.content.cloneNode(true);
      dialog = fragment.querySelector('dialog');

      if (!dialog) {
        console.warn(`[Size guide] Template #${templateId} has no dialog.`);
        return;
      }

      document.body.appendChild(fragment);
      mountedDialogs.set(templateId, dialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
      });
    }

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.documentElement.style.overflow = 'hidden';
  };

  const handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest('[data-size-guide-open]');

    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      openDialog(openButton);
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');

    if (closeButton) {
      event.preventDefault();
      closeDialog(closeButton.closest('dialog'));
      return;
    }

    // Tabbed size guide: age-group tabs (Toddler / Youth / Adults).
    const ageTabButton = event.target.closest('[data-age-tab]');

    if (ageTabButton) {
      event.preventDefault();
      const dialog = ageTabButton.closest('dialog');
      if (!dialog) return;

      const targetId = ageTabButton.dataset.ageTab;

      dialog.querySelectorAll('[data-age-tab]').forEach((button) => {
        button.classList.toggle('is-active', button === ageTabButton);
      });

      dialog.querySelectorAll('[data-age-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.agePanel === targetId);
      });

      return;
    }

    // Tabbed size guide: CM / Inch toggle for the merchant-pasted chart HTML.
    // Scoped to the active age panel so each age group keeps its own choice.
    const chartTabButton = event.target.closest('[data-chart-tab]');

    if (chartTabButton) {
      event.preventDefault();
      const panel = chartTabButton.closest('[data-age-panel]');
      if (!panel) return;

      const targetUnit = chartTabButton.dataset.chartTab;

      panel.querySelectorAll('[data-chart-tab]').forEach((button) => {
        button.classList.toggle('is-active', button === chartTabButton);
      });

      panel.querySelectorAll('[data-chart-panel]').forEach((chart) => {
        chart.classList.toggle('is-active', chart.dataset.chartPanel === targetUnit);
      });

      return;
    }

    const unitButton = event.target.closest('[data-size-unit]');
    if (!unitButton) return;

    event.preventDefault();
    const dialog = unitButton.closest('dialog');
    if (!dialog) return;

    dialog.querySelectorAll('[data-size-unit]').forEach((button) => {
      button.classList.toggle('is-active', button === unitButton);
    });

    dialog.querySelectorAll('[data-cm]').forEach((cell) => {
      const centimetres = cell.dataset.cm;

      if (unitButton.dataset.sizeUnit === 'cm') {
        cell.textContent = `${centimetres.replace('-', '–')} cm`;
        return;
      }

      cell.textContent = `${centimetres
        .split('-')
        .map((value) => (Number(value) / 2.54).toFixed(1))
        .join('–')} in`;
    });
  };

  // Capture mode prevents the theme's variant picker from swallowing the click.
  document.addEventListener('click', handleClick, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.documentElement.style.overflow = '';
    }
  });

  window.NativeSizeGuide = true;
})();
